<template>
  <div>
    <!-- HEADER -->
    <section id="lp-header" class="py-5">
      <div class="container text-center d-lg-flex align-items-lg-center justify-content-center py-5">
        <div>
          <div>
            <h2 class="font-size-xLarge font-weight-bold">EVENTO #03 - HUMOR</h2>
          </div>
          <p class="mb-lg-0">Publique um texto ou conto de humor e concorra a um <strong>Smart Watch</strong> e muitos outros prêmios!</p>
        </div>
      </div>
    </section> <!-- END HEADER -->
    <!-- BUTTONS -->
    <section id="buttons" class="text-center">
      <div>
        <Button
          class="btn btn-color3 mr-3"
          @click="toggleTheme"
        >
          Entenda o tema
        </Button>
        <router-link
          :to="{ name: 'posts.create', query: { tags: 'meuhumor' } }"
          target="_blank"
          class="btn btn-primary"
          v-if="authenticated"
        >
          Escrever texto
        </router-link>
        <Button
          class="btn btn-primary"
          v-b-modal.auth-modal
          v-else
        >
          Escrever texto
        </Button>
      </div>
    </section> <!-- END BUTTONS -->
    <!-- ABOUT THEME -->
    <section
      id="about-theme"
      ref="aboutTheme"
      :class="{
        hidden: !aboutThemeVisible
      }"
    >
      <div class="container py-5 text-center text-md-left">
        <h2 class="font-size-medium font-weight-bold text-color2">O que é um texto de humor?</h2>
        <p>Um texto ou conto de humor é uma narrativa capaz de gerar um divertimento ao leitor, pelos eventos que são descritos ou pela maneira que são contados.</p>
        <p>Geralmente, trata-se de uma situação ou história cômica com linguagem simples e descontraída. É possível, também, contar alguma piada e adicionar imagens que ajudem a compor a história.</p>
        <h2 class="font-size-medium font-weight-bold text-color2">Fato ou ficção?</h2>
        <p>A história pode ser fictícia ou verdadeira, fica à critério de cada autor. Pode ser retratado um acontecimento próprio ou terceiro, ou até mesmo algo que nunca aconteceu. O importante é ser engraçado 😉</p>
        <h2 class="font-size-medium font-weight-bold text-color2">Exemplos de narrativas de humor</h2>
        <div class="post-thumbs-listing listing-rowed items-3-per-row mt-4">
          <ul class="list-wrap">
            <li
              class="list-item"
              v-for="(item, index) in items"
              :key="index"
            >
              <template v-if="item.type === 'post'">
                <PostThumbCard
                  :post="item"
                  linkTarget="_blank"
                />
              </template>
              <template v-else-if="item.type === 'video'">
                <a
                  :href="item.url"
                  target="_blank"
                >
                  <div class="post-card card-small">
                    <div class="image-wrap has-cover">
                      <div class="image" :style="`background-image: url('${item.cover}');`"></div>
                      <img class="cover-sizing" src="/images/default/card-no-cover.png" alt="" />
                    </div>
                    <div class="post-info">
                      <div class="post-title">
                        <h2 :title="item.title">{{ item.title }}</h2>
                      </div>
                    </div>
                  </div>
                </a>
              </template>
            </li>
          </ul>
        </div>
        <div class="mt-3 text-center">
          <Button
            class="btn btn-primary"
            @click="toggleTheme"
          >
            Fechar
          </Button>
        </div>
      </div>
    </section> <!-- END ABOUT THEME -->
    <!-- STEPS -->
    <section id="steps" class="mt-3">
      <div class="container py-4">
        <div class="d-flex flex-column flex-md-row justify-content-center justify-content-md-between mx-md-auto col-md-11">
          <div class="step mb-5 mb-md-0">
            <img src="/images/events/icons/user_v2.png" alt="Crie perfil" />
            <p>Crie seu perfil <br/>na Scriv</p>
          </div>
          <div class="step mb-5 mb-md-0">
            <img src="/images/events/icons/write_v2.png" alt="Escreva" />
            <p>Escreva <br/>sua narrativa</p>
          </div>
          <div class="step mb-5 mb-md-0">
            <img src="/images/events/icons/tag_v2.png" alt="Tag" />
            <p>Insira a tag<br/><span class="text-color2 font-weight-bold">meuhumor</span></p>
          </div>
          <div class="step">
            <img src="/images/events/icons/publish_v2.png" alt="Publique" />
            <p>Clique em<br/>publicar</p>
          </div>
        </div>
      </div>
    </section> <!-- END STEPS -->
    <!-- PRIZES -->
    <div id="prizes">
      <div class="container py-3 text-center">
        <h2 class="font-size-xLarge mb-3"><span class="highlighted highlight-left">Premiações</span></h2>
        <p class="mb-5">A Scriv vai premiar os cinco melhores contos de humor</p>
        <div class="mx-auto col-md-11 d-flex flex-column flex-md-row justify-content-center justify-content-md-between">
          <div class="px-0 prize-item mb-4 mb-md-0">
            <div class="author-image-circle image-lg background-cover mx-auto shadow-light mb-3" style="background-image: url('/images/events/03-humor/award-relogio.jpg');"></div>
            <span>Smart Watch Xiaomi</span>
          </div>
          <div class="px-0 prize-item mb-4 mb-md-0">
            <div class="author-image-circle image-lg background-cover mx-auto shadow-light mb-3" style="background-image: url('/images/events/03-humor/award-livros.jpg');"></div>
            <span>Livros Físicos</span>
          </div>
          <div class="px-0 prize-item mb-4 mb-md-0">
            <div class="author-image-circle image-lg background-cover mx-auto shadow-light mb-3" style="background-image: url('/images/events/03-humor/award-kits.jpg');"></div>
            <span>Kits Scriv</span>
          </div>
          <div class="px-0 prize-item">
            <div class="author-image-circle image-lg background-cover mx-auto shadow-light mb-3" style="background-image: url('/images/events/03-humor/award-meias.jpg');"></div>
            <span>Meias Hold Up</span>
          </div>
          <div class="px-0 prize-item">
            <div class="author-image-circle image-lg background-cover mx-auto shadow-light mb-3" style="background-image: url('/images/events/03-humor/award-medalha.jpg');"></div>
            <span>Medalha no Perfil</span>
          </div>
        </div>
      </div>
    </div> <!-- END PRIZES -->
    <!-- JUDGES -->
    <section id="judges">
      <div class="container py-4 text-center">
        <h2 class="font-size-xLarge mb-5"><span class="highlighted highlight-left">Jurados</span></h2>
        <div class="mx-auto col-md-11 d-flex flex-column flex-md-row justify-content-center justify-content-md-between">
          <div class="col-md-4 mb-4 mb-md-0">
            <div class="author-image-circle image-lg background-cover mx-auto shadow-light mb-3" style="background-image: url('/images/events/03-humor/judge-leo.jpg');"></div>
            <span class="d-block font-weight-bold">Leo Bacci</span>
            <p class="mb-1 font-size-small">Humorista, youtuber e autor do <br class="d-none d-lg-block"/>livro "Bom Dia Leo".</p>
            <ul class="d-flex justify-content-center style-unlisted font-size-medium">
              <li class="mr-2">
                <a href="https://twitter.com/bomdialeo" class="link-color2" target="_blank"><i class="fa fa-twitter"></i></a>
              </li>
              <li>
                <a href="https://www.instagram.com/bomdialeo/" class="link-color2" target="_blank"><i class="fa fa-instagram"></i></a>
              </li>
            </ul>
          </div>
          <div class="col-md-4 mb-4 mb-md-0">
            <div class="author-image-circle image-lg background-cover mx-auto shadow-light mb-3" style="background-image: url('/images/events/03-humor/judge-deborista.jpg');"></div>
            <span class="d-block font-weight-bold">Debora Salvo</span>
            <p class="mb-1 font-size-small">Criadora de conteúdo, apresentadora de <br class="d-none d-lg-block"/>podcast e contadora de boas histórias.</p>
            <ul class="d-flex justify-content-center style-unlisted font-size-medium">
              <li class="mr-2">
                <a href="https://www.twitter.com/deborista" class="link-color2" target="_blank"><i class="fa fa-twitter"></i></a>
              </li>
              <li>
                <a href="https://www.instagram.com/deborista/" class="link-color2" target="_blank"><i class="fa fa-instagram"></i></a>
              </li>
            </ul>
          </div>
          <div class="col-md-4 mb-4 mb-md-0">
            <div class="author-image-circle image-lg background-cover mx-auto shadow-light mb-3" style="background-image: url('/images/events/03-humor/judge-dudu.jpg');"></div>
            <span class="d-block font-weight-bold">Dudu Trindade</span>
            <p class="mb-1 font-size-small">Publicitário (aspirante), criador de playlists <br class="d-none d-lg-block"/>no Spotify e aficionado por comédia.</p>
            <ul class="d-flex justify-content-center style-unlisted font-size-medium">
              <li>
                <a href="https://www.instagram.com/duduftr/" class="link-color2" target="_blank"><i class="fa fa-instagram"></i></a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
    <!-- RULES -->
    <section id="rules">
      <div class="container py-5 col-md-8">
        <h2 class="text-uppercase font-size-large font-weight-bold text-color2 text-center mb-3">Regras de participação</h2>
        <ul class="pl-5">
          <li>O texto publicado deve ter, no máximo, 2.200 palavras (mas adoramos textos curtos);</li>
          <li>O participante precisa escrever de um perfil próprio na Scriv, sem utilizar perfil de terceiros;</li>
          <li>O texto publicado precisa ser original e não ter sido publicado em outra plataforma;</li>
          <li>O texto publicado precisar conter a tag <strong class="text-color2">meuhumor</strong> e estar em modo Público na plataforma;</li>
          <li>Um texto publicado na Scriv pode ser incluído no evento, desde que tenha a tag acima.</li>
        </ul>
        <div v-show="rulesVisible">
          <h2 class="text-uppercase font-size-large font-weight-bold text-color2 text-center mb-3">Condições Gerais</h2>
          <ul class="pl-5">
            <li>O texto publicado precisa respeitar integralmente as Regras de Moderação de nossa plataforma;</li>
            <li>Como o texto pode ser editado, será considerado o texto ativo no dia da deliberação dos jurados;</li>
            <li>Qualquer violação destas regras promoverá a desclassificação automática do texto e respectivo autor;</li>
            <li>Qualquer situação não prevista nestas condições será avaliada individualmente;</li>
            <li>Não poderão participar pessoas com relações comerciais ou empregatícias com a Scriv;</li>
            <li>Não poderão participar parentes de 1º grau de qualquer membro da banca de jurados.</li>
          </ul>
          <h2 class="text-uppercase font-size-large font-weight-bold text-color2 text-center mb-3">Banca de Jurados</h2>
          <ul class="pl-5">
            <li>Os jurados serão: Leo Bacci, Debora Salvo, e Dudu Trindade.</li>
            <li>Os jurados terão igual poder de voto e ordem de grandeza entre si, sem exceções;</li>
            <li>Os jurados não possuem relação direta com os autores e respectivos textos publicados;</li>
            <li>Os jurados não possuem conflitos de interesse em relação ao tema selecionado e respectivas premiações.</li>
          </ul>
          <h2 class="text-uppercase font-size-large font-weight-bold text-color2 text-center mb-3">Metodologia</h2>
          <ul class="pl-5">
            <li>Todos os textos inscritos passarão por uma pré-banca formada por integrantes da Scriv;</li>
            <li>Os textos selecionados serão lidos por todos os jurados, sem interferência da Scriv;</li>
            <li>Os jurados darão uma nota de 0 a 10 para cada uma das seguintes categorias: originalidade, narrativa e ortografia;</li>
            <li>A nota final de cada texto será formulada por essas notas individuais das categorias;</li>
            <li>Os textos serão então ranqueados pela média das notas, da primeira à quinta colocação.</li>
          </ul>
          <h2 class="text-uppercase font-size-large font-weight-bold text-color2 text-center mb-3">Premiações</h2>
          <ul class="pl-5">
            <li>Serão premiados os cinco melhores textos, de acordo com a metodologia acima;</li>
            <li>Apenas um texto por autor poderá figurar entre os cinco melhores textos;</li>
            <li>Os textos que ficarem em 4º e 5º lugar receberão um kit personalizado da Scriv, um par de meias Hold Up e uma medalha no perfil;</li>
            <li>Os textos que ficarem em 2º e 3º lugar receberão o kit Scriv, um livro físico, o par de meias Hold Up e a medalha no perfil;</li>
            <li>O texto vencedor receberá todos os prêmios citados acima e ainda ganhará um Smart Watch Xiaomi;</li>
            <li>Entraremos em contato com os vencedores em até 5 (cinco) dias após a divulgação dos mesmos, pelo email cadastrado na Scriv;</li>
            <li>Para a entrega do prêmio, o vencedor deverá responder em até 5 (cinco) dias úteis com o endereço de entrega desejado.</li>
          </ul>
        </div>
      </div>
    </section> <!-- END RULES -->
    <div class="text-center read-more-rules position-relative">
      <Button
        class="btn btn-primary"
        @click="rulesVisible = !rulesVisible"
      >
        <span v-if="rulesVisible">Fechar</span>
        <span v-else>Ver regulamento completo</span>
      </Button>
    </div>
    <!-- DATES -->
    <section id="dates" class="py-3">
      <div class="container py-5">
        <div class="col-md-10 mx-auto d-flex flex-column flex-md-row justify-content-center justify-content-md-between text-center mt-3 text-white">
          <div class="col-md-3 mb-4 mb-md-0">
            <span class="d-block font-weight-bold font-size-large">01/11</span>
            <p class="mb-0">
              <strong>Início</strong><br/>do evento
            </p>
          </div>
          <div class="col-md-3 mb-4 mb-md-0">
            <span class="d-block font-weight-bold font-size-large">15/11</span>
            <p class="mb-0">
              <strong>Fim</strong><br/>do evento
            </p>
          </div>
          <div class="col-md-3 mb-4 mb-md-0">
            <span class="d-block font-weight-bold font-size-large">22/11</span>
            <p class="mb-0">
              <strong>Deliberação</strong><br/>dos jurados
            </p>
          </div>
          <div class="col-md-3">
            <span class="d-block font-weight-bold font-size-large">06/12</span>
            <p class="mb-0">
              <strong>Anúncio</strong><br/>dos vencedores
            </p>
          </div>
        </div>
      </div>
    </section> <!-- END DATES -->
    <!-- CTA -->
    <section>
      <div class="container py-5 text-center">
        <h2 class="font-size-xLarge">Comece a participar <br/>agora mesmo</h2>
        <router-link
          :to="{ name: 'posts.create', query: { tags: 'meuhumor' } }"
          target="_blank"
          class="btn btn-primary mt-2"
          v-if="authenticated"
        >
          Escrever texto
        </router-link>
        <Button
          class="btn btn-primary mt-2"
          v-b-modal.auth-modal
          v-else
        >
          Escrever texto
        </Button>
      </div>
    </section> <!-- END CTA -->
  </div>
</template>

<script>

import { mapState } from 'vuex'

import Button from '@/components/common/Button/Button'
import PostThumbCard from '@/components/post/PostThumbCard'

export default {
  components: {
    Button,
    PostThumbCard
  },
  metaInfo: {
    title: 'Evento #03 - Humor'
  },
  data () {
    return {
      aboutThemeVisible: false,
      rulesVisible: false,
      items: [
        {
          type: 'post',
          cover: 'https://cdn.scriv.com.br/storage/images/9RPicUkCrnS6QThvJkbxhsPfRkkFkfrA93Y15rtK.jpg',
          slug: 'o-burrissimo-do-manduca-6013',
          title: 'O burríssimo do Manduca ',
          status: 'published',
          user: {
            name: 'Cyntia Fonseca',
            username: 'cyntia2fonseca',
            avatar: 'https://cdn.scriv.com.br/storage/images/bbIYStn4Xjo3JbV9CxKB7XJGvZfJPwn28molCFJt.jpg'
          }
        },
        {
          type: 'post',
          cover: 'https://cdn.scriv.com.br/storage/images/iRiPeSmUB5Wl8Pu7SmYN8vKgk4luzXusgvNlZb6S.jpg',
          slug: 'a-foto-3345',
          title: 'A foto',
          status: 'published',
          user: {
            name: 'Danilo Heitor',
            username: 'kadjoman',
            avatar: 'https://cdn.scriv.com.br/storage/images/lDoJ8zZcLUOEic60KzmV37ANQd1zyGScYNbLuPpe.jpg'
          }
        },
        {
          type: 'post',
          cover: 'https://cdn.scriv.com.br/storage/images/n6EJR6G6mX4gf2qHMC4IdD7o0ec2igwLo8B22R86.jpg',
          slug: 'opinto',
          title: 'O pinto do peixeiro ',
          status: 'published',
          user: {
            name: 'Fernando Gurjão Sampaio',
            username: 'tantotupiassu',
            avatar: 'https://cdn.scriv.com.br/storage/images/OZmems9OXXpl3kYTvvfCPM68Q2m819QyqTw6xJNH.jpg'
          }
        }
      ]
    }
  },
  computed: {
    ...mapState('auth', {
      authenticated: state => state.authenticated
    })
  },
  methods: {
    toggleTheme () {
      this.aboutThemeVisible = !this.aboutThemeVisible
    }
  }
}
</script>

<style lang="scss" scoped>

#lp-header {
  background: url('/images/events/03-humor/header-bg.png?v=1') center center no-repeat;
  background-size: cover;
  margin-top: -3rem !important;
  position: relative;

  h2 {
    color: #716b6a;
    text-shadow: 0 5px 0 rgba(238,91,69, 0.46);
    position: relative;
    display: inline-block;

    &::before {
      content: '';
      background: #ff9d8e;
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 24px;
      z-index: -1;
    }
  }

  p {
    color: #372b2f;
  }

  .container {
    position: relative;
    z-index: 2;
  }
}

#buttons {
  margin-top: -22px;
  z-index: 3;
  position: relative;
}

#about-theme {
  height: auto;
  background: #eee;
  overflow: hidden;

  @include desktop {
    margin-top: -22px;
  }

  &.hidden {
    height: 0px;

    @include desktop {
      margin-top: 0;
    }
  }

  .post-card {
  -webkit-border-radius: $radius_regular;
  -moz-border-radius: $radius_regular;
  border-radius: $radius_regular;
  overflow: hidden;
  -webkit-box-shadow: 0 0 10px 0 rgba(0,0,0,0.3);
  box-shadow: 0 0 10px 0 rgba(0,0,0,0.3);
  background-color: #fff;
  position: relative;
  color: #fff;

  &:hover {
    .image-wrap {
      .image {
        transform: scale(1.1);
      }
    }
  }

  .image-wrap {
    &::after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0,0,0,0.25);
    }

    .image {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
      transition: all 0.6s ease-out;
    }

    .cover-sizing {
      opacity: 0;
    }

    &.has-cover {
      &::after {
        background: rgba(0,0,0,0.1);
      }
    }
  }

  .post-info {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    text-align: left;
    padding: 15px;

    .post-title {

      h2 {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        font-size: $font_size_regular;
        font-weight: bold;
        text-transform: uppercase;
      }
    }
  }
}
}

#steps {
  .step {
    position: relative;
    text-align: center;

    @include desktop {
      width: 25%;
    }

    &:last-child {
      &::after {
        display: none;
      }
    }

    &::after {
      content: '\f107';
      font-family: 'FontAwesome';
      font-size: 40px;
      color: $color2;
      position: absolute;
      bottom: -44px;
      left: calc(50% - 13px);

      @include tablet {
        content: '\f105';
        bottom: auto;
        top: 40px;
        left: auto;
        right: -25px;
      }

      @include desktop {
        right: -12px;
      }
    }
  }
}

#prizes, #judges {
  .author-image-circle.image-lg {
    width: 150px;
    height: 150px;

    @include tablet {
      width: 120px;
      height: 120px;
    }

    @include desktop {
      width: 150px;
      height: 150px;
    }
  }
}

#prizes {
  .prize-item {
    @include desktop {
      width: calc(100%/5);
    }
  }
}

#rules {
  background: url('/images/events/bg-paper.jpg?v=2') top center no-repeat;
  background-size: cover;

  ul {
    li {
      list-style: disc;
    }
  }
}

.read-more-rules {
  margin-top: -22px;
  margin-bottom: -22px;
  position: relative;
  z-index: 3;
}

#dates {
  background: url('/images/events/01-causos/dates-bg.jpg') center center no-repeat;
  background-size: cover;
}

::v-deep {
  .post-thumbs-carousel {
    .post-info {
      display: none;
    }
  }
}
</style>
